import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import "@/utils/rem";
import 'element-plus/theme-chalk/index.css';

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
